











































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { reviewGetters } from '~/utils/ct';
import Review from '~/components/molecules/Product/RatingsReviews/Review.vue';
import { ProductReview } from '~/types/product/attribute/ProductReview';
import ReviewsStars from '~/components/atoms/ReviewsStars.vue';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import ProductAddReview from '~/components/molecules/Product/ProductAddReview.vue';
import PaginationReviews from '@/components/molecules/Pagination/PaginationReviews.vue';
import SortingReviews from '~/components/molecules/Product/RatingsReviews/SortingReviews.vue';
import { REVIEW_ID } from '~/constants/pagination';
import floorToOneDecimal from '~/helpers/floorToOneDecimal';
import ProductAnchorTitle from '~/components/atoms/Product/ProductAnchorTitle/ProductAnchorTitle.vue';

export default defineComponent({
  name: 'RatingsReviews',
  components: {
    Review,
    ReviewsStars,
    Button,
    ProductAddReview,
    PaginationReviews,
    SortingReviews,
    ProductAnchorTitle,
  },
  props: {
    reviews: {
      type: Array as PropType<Array<ProductReview>>,
      required: true,
    },
    reviewsCount: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isFormShowed = ref(false);
    const RatingNumber = computed(() => floorToOneDecimal(props.rating));
    const showReviewForm = () => {
      isFormShowed.value = true;
    };
    return {
      reviewGetters,
      RatingNumber,
      isFormShowed,
      showReviewForm,
      REVIEW_ID,
    };
  },
});
